import giftPic05 from '../../../assets/images/gifts/05gift.png'
import giftPic1 from '../../../assets/images/gifts/1gift.png'
import giftPic2 from '../../../assets/images/gifts/2gift.png'
import giftPic5 from '../../../assets/images/gifts/5gift.png'
import giftPic10 from '../../../assets/images/gifts/10gift.png'
import giftPic20 from '../../../assets/images/gifts/20gift.png'
import giftPic50 from '../../../assets/images/gifts/50gift.png'

export default [
  { id: 1, price: 0.5, image: giftPic05 },
  { id: 2, price: 1, image: giftPic1 },
  { id: 3, price: 2, image: giftPic2 },
  { id: 4, price: 5, image: giftPic5 },
  { id: 5, price: 10, image: giftPic10 },
  { id: 6, price: 20, image: giftPic20 },
  { id: 7, price: 50, image: giftPic50 }
]
